import type { FC } from "react";
import type { SessionEducationalResourceItem } from "../../interfaces/sessionDetails";
import { useLocalization } from "../../stores/localizationContext";
import "./SessionResourceList.scss";

type SessionResourceListProps = {
  titleKey: string;
  titleFallback: string;
  items: SessionEducationalResourceItem[];
  emptyKey: string;
  emptyFallback: string;
};

function stripExtension(filename: string): string {
  return filename.replace(/\.[^.]+$/, "");
}

export const SessionResourceList: FC<SessionResourceListProps> = ({
  titleKey,
  titleFallback,
  items,
  emptyKey,
  emptyFallback,
}) => {
  const { t } = useLocalization();

  const handleDownloadAll = () => {
    items.forEach((item) => {
      window.open(item.educational_resource_url, "_blank", "noopener,noreferrer");
    });
  };

  return (
    <section className="session-resource-list" aria-labelledby={`heading-${titleKey}`}>
      <div className="session-resource-list__head">
        <h2 id={`heading-${titleKey}`} className="session-resource-list__title">
          {t(titleKey, titleFallback)}
        </h2>
        <button
          type="button"
          className="session-resource-list__download-btn"
          onClick={items.length > 0 ? handleDownloadAll : undefined}
          disabled={items.length === 0}
          aria-label={t("download_all", "Download all")}
        >
          <i className="f-icon arrow-down-icon" aria-hidden="true" />
        </button>
      </div>
      <div className="session-resource-list__divider" />
      {items.length === 0 ? (
        <p className="session-resource-list__empty">{t(emptyKey, emptyFallback)}</p>
      ) : (
        <ul className="session-resource-list__items">
          {items.map((item) => (
            <li key={item.educational_resource_id} className="session-resource-list__row">
              <a
                href={item.educational_resource_url}
                target="_blank"
                rel="noopener noreferrer"
                download={item.educational_resource_name}
                className="session-resource-list__link"
              >
                <span className="session-resource-list__name">
                  {stripExtension(item.educational_resource_name)}
                </span>
              </a>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
